"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var quards_1 = require("../../../utils/quards");
var atoms_1 = require("../../styles/atoms");
var selectors_1 = require("../selectors");
var SeoBannerImage_1 = __importDefault(require("./SeoBannerImage"));
var SeoHeader = function () {
    var image = (0, quards_1.guardString)((0, selectors_1.useSeoTypeSelector)('bannerImageUrl'));
    var title = (0, quards_1.guardString)((0, selectors_1.useSeoTypeSelector)('h1Text'));
    var description = (0, quards_1.guardString)((0, selectors_1.useSeoTypeSelector)('regularText'));
    var hasImage = function (src) {
        return typeof src === "string" && !/missing/.test(src);
    };
    return hasImage(image) ? (react_1.default.createElement("div", { className: "store-info" },
        react_1.default.createElement(SeoBannerImage_1.default, { src: "bannerImageUrl", alt: "h1Text", className: "store-info__image" }),
        react_1.default.createElement("div", { className: "store-info__content" },
            react_1.default.createElement(atoms_1.Header1, { style: { marginBottom: 16 } }, title)))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(atoms_1.Header1, { style: { marginBottom: 16 } }, title)));
};
exports.default = SeoHeader;
